import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default  new Vuex.Store({
  state: {
    items :[[["O", "O", ""], ["Filipe", "O", ""], ["Oliveira", "O", ""], ["é", "O", ""], ["o", "O", ""], ["Conde", "O", ""], ["da", "O", ""], ["Barca", "O", ""]],
    [["O", "O", ""], ["Filipe", "B", "Pessoa"], ["Oliveira", "I", "Pessoa"], ["é", "O", ""], ["o", "O", ""], ["Conde", "B", "Profissao"], ["da", "O", ""], ["Barca", "B", "Local"]], 
    [["O", "O", ""], ["Filipe", "B", "Pessoa"], ["Oliveira", "I", "Pessoa"], ["é", "O", ""], ["o", "O", ""], ["Conde", "B", "Profissao"], ["da", "O", ""], ["Barca", "B", "Local"]],
    [["O", "O", ""], ["Filipe", "O", ""], ["Oliveira", "O", ""], ["é", "O", ""], ["o", "O", ""], ["Conde", "O", ""], ["da", "O", ""], ["Barca", "O", ""]],
    [["O", "O", ""], ["Filipe", "O", ""], ["Oliveira", "O", ""], ["é", "O", ""], ["o", "O", ""], ["Conde", "O", ""], ["da", "O", ""], ["Barca", "O", ""]],
    [["O", "O", ""], ["Filipe", "O", ""], ["Oliveira", "O", ""], ["é", "O", ""], ["o", "O", ""], ["Conde", "O", ""], ["da", "O", ""], ["Barca", "O", ""]],
    [["O", "O", ""], ["Filipe", "O", ""], ["Oliveira", "O", ""], ["é", "O", ""], ["o", "O", ""], ["Conde", "O", ""], ["da", "O", ""], ["Barca", "O", ""]],
    [["O", "O", ""], ["Filipe", "O", ""], ["Oliveira", "O", ""], ["é", "O", ""], ["o", "O", ""], ["Conde", "O", ""], ["da", "O", ""], ["Barca", "O", ""]],
    [["O", "O", ""], ["Filipe", "O", ""], ["Oliveira", "O", ""], ["é", "O", ""], ["o", "O", ""], ["Conde", "O", ""], ["da", "O", ""], ["Barca", "O", ""]],
    [["O", "O", ""], ["Filipe", "O", ""], ["Oliveira", "O", ""], ["é", "O", ""], ["o", "O", ""], ["Conde", "O", ""], ["da", "O", ""], ["Barca", "O", ""]],
    [["O", "O", ""], ["Filipe", "O", ""], ["Oliveira", "O", ""], ["é", "O", ""], ["o", "O", ""], ["Conde", "O", ""], ["da", "O", ""], ["Barca", "O", ""]],
    [["O", "O", ""], ["Filipe", "O", ""], ["Oliveira", "O", ""], ["é", "O", ""], ["o", "O", ""], ["Conde", "O", ""], ["da", "O", ""], ["Barca", "O", ""]],
    [["O", "O", ""], ["Filipe", "O", ""], ["Oliveira", "O", ""], ["é", "O", ""], ["o", "O", ""], ["Conde", "O", ""], ["da", "O", ""], ["Barca", "O", ""]],
    [["O", "O", ""], ["Filipe", "O", ""], ["Oliveira", "O", ""], ["é", "O", ""], ["o", "O", ""], ["Conde", "O", ""], ["da", "O", ""], ["Barca", "O", ""]],
    [["O", "O", ""], ["Filipe", "O", ""], ["Oliveira", "O", ""], ["é", "O", ""], ["o", "O", ""], ["Conde", "O", ""], ["da", "O", ""], ["Barca", "O", ""]],
    [["O", "O", ""], ["Filipe", "O", ""], ["Oliveira", "O", ""], ["é", "O", ""], ["o", "O", ""], ["Conde", "O", ""], ["da", "O", ""], ["Barca", "O", ""]],
    [["O", "O", ""], ["Filipe", "O", ""], ["Oliveira", "O", ""], ["é", "O", ""], ["o", "O", ""], ["Conde", "O", ""], ["da", "O", ""], ["Barca", "O", ""],["O", "O", ""], ["Filipe", "O", ""], ["Oliveira", "O", ""], ["é", "O", ""], ["o", "O", ""], ["Conde", "O", ""], ["da", "O", ""], ["Barca", "O", ""],["O", "O", ""], ["Filipe", "O", ""], ["Oliveira", "O", ""], ["é", "O", ""], ["o", "O", ""], ["Conde", "O", ""], ["da", "O", ""], ["Barca", "O", ""],["O", "O", ""], ["Filipe", "O", ""], ["Oliveira", "O", ""], ["é", "O", ""], ["o", "O", ""], ["Conde", "O", ""], ["da", "O", ""], ["Barca", "O", ""],["O", "O", ""], ["Filipe", "O", ""], ["Oliveira", "O", ""], ["é", "O", ""], ["o", "O", ""], ["Conde", "O", ""], ["da", "O", ""], ["Barca", "O", ""]]],
    newitems: [],
    lineIndex: -1,
    selectedLineIndex: 0,
    tokenIndex: -1,
    deleted:[],
    loading:false,
    debugMode:true,
    label1Color:"#ddd", //#E4E7D2 #ddd
    label2Color:"#7AECEC",
    label3Color:"#AA9CFC",
    label4Color:"#FECA74",
    label5Color:"#BFE1D9",
    label1:"Organizacao",
    label2:"Pessoa",
    label3:"Local",
    label4:"Profissao",
    label5:"Data",
    label1Key:"1",
    label2Key:"2",
    label3Key:"3",
    label4Key:"4",
    label5Key:"5",
  },
  getters: {
    // put sychronous functions for changing state e.g. add, edit, delete
  },
  mutations: {
    // put sychronous functions for changing state e.g. add, edit, delete
  },
})